// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Yfrt","buttons":"Footer_buttons__1jYFn"};